import RadioGroup from '@components/molecules/RadioGroup';
import { UserIntent } from '@graphql/generated';
import {
  QuoteInitialForm,
  UserIntentFormResult,
} from '@lib/data/typesQuestions';
import GridBox from 'components/atoms/GridBox';
import { FC } from 'react';
import { useForm } from 'react-hook-form';
import styled from 'styled-components';

const Form = styled.form``;

interface Props {
  onSubmit: (data: UserIntentFormResult & { oldPolicy: null }) => void;
  item: QuoteInitialForm;
}

const UserIntentForm: FC<Props> = ({ onSubmit, item }) => {
  const { register, handleSubmit, errors } =
    useForm<{ userIntent: UserIntent }>();

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <GridBox justifyContent="center">
        <GridBox width={[1, 0.5, 0.5]}>
          <RadioGroup
            inputRef={register({ required: 'Escolha uma das opções' })}
            errorMessage={errors.userIntent?.message}
            onSelected={(value) => {
              onSubmit({
                userIntent: value as UserIntent,
                oldPolicy: null,
              });
            }}
            name="userIntent"
            options={[
              {
                label: 'Meu seguro venceu',
                value: UserIntent.Expired,
                example: 'Preciso renovar o seguro',
              },
              {
                label: 'Comprei um veículo novo',
                value: UserIntent.NeedInsuranceNow,
                example: 'Acabei de comprar e preciso de seguro',
              },
              {
                label: 'Vou comprar um veículo em breve',
                value: UserIntent.BuyingVehicleSoon,
                example: 'Pretendo comprar, e já estou buscando o seguro',
              },
              {
                label: 'Tenho um veículo, mas estava rodando sem seguro',
                value: UserIntent.DrivingWithoutInsurance,
              },
              {
                label: 'Não tenho o veículo',
                value: UserIntent.Curious,
                example: 'Avaliando custos, nada sério ainda',
              },
            ].map((o) => {
              if (o.value === item.userIntent) return { ...o, checked: true };

              return o;
            })}
          />
        </GridBox>
      </GridBox>
    </Form>
  );
};

export default UserIntentForm;
